import request from './axios';

// 菜单相关 API
export default {
  // 获取菜单列表
  getMenus() {
    // 调用实际的API接口获取菜单数据
    return request({
      url: '/menus',
      method: 'get',
    });
  },

  // 获取菜单详情
  getMenuDetail(id) {
    return request({
      url: `/menus/${id}`,
      method: 'get',
    });
  },

  // 创建菜单
  createMenu(data) {
    return request({
      url: '/menus',
      method: 'post',
      data,
    });
  },

  // 更新菜单
  updateMenu(id, data) {
    return request({
      url: `/menus/${id}`,
      method: 'put',
      data,
    });
  },

  // 删除菜单
  deleteMenu(id) {
    return request({
      url: `/menus/${id}`,
      method: 'delete',
    });
  },

  // 获取菜单权限列表
  getMenuPermissions(menuId) {
    return request({
      url: `/menus/${menuId}/permissions`,
      method: 'get',
    });
  },

  // 更新菜单权限
  updateMenuPermissions(menuId, data) {
    return request({
      url: `/menus/${menuId}/permissions`,
      method: 'put',
      data,
    });
  },
};
